{
  "FormEngineButtonElement": {
    "title": "Knopf"
  },
  "mask": {
    "FormEngineButtonElement": {
      "isBlock": "Block",
      "variant": "Variante",
      "requireValid": "Abschicken bei Seitenfehler deaktivieren",
      "requireOnline": "Abschicken deaktivieren wenn offline",
      "action": "Handlung",
      "eventName": "Signal",
      "pageName": "Zielseite",
      "url": "URL",
      "urlTarget": "Ziel"
    }
  }
}